// A form field: its label over the control, then a hint or, when there is
// one, the error in the hint's place. `as="div"` for a set of controls one
// <label> can't wrap (radios, a field with buttons of its own).
export default function Field({ label, hint = null, error = null, as: Tag = "label", className = "", children }) {
    return (
        <Tag className={`grid min-w-0 content-start gap-[6px] ${className}`}>
            {label ? <span className="text-[12.5px] font-medium leading-[1.3] text-[color:var(--ink)]">{label}</span> : null}
            {children}
            {error ? (
                <span role="alert" className="text-[12px] leading-[1.4] text-[color:var(--danger)]">{error}</span>
            ) : hint ? (
                <span className="text-[12px] leading-[1.4] text-[color:var(--muted)]">{hint}</span>
            ) : null}
        </Tag>
    );
}
